import { writable } from 'svelte/store';
import { bodyTextColorDefault, bodyTextRadiusDefault } from './BodyTextStoreDefaults';

// border radius
export const bodyTextRadius = writable(bodyTextRadiusDefault);

// background color code
export const bodyTextColor = writable(bodyTextColorDefault);
